module.exports = __webpack_public_path__ + "static/media/propic-5.a5dc4f80.png";